<script>
export default {
  props: {
    fill: {
      type: String,
      default: '#000'
    }
  }
}
</script>

<template>
  <svg width="120" height="60" viewBox="0 0 120 60" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M120 60C120 44.087 113.679 28.8258 102.426 17.5736C91.1742 6.32141 75.913 1.2014e-06 60 0C44.087 -1.2014e-06 28.8258 6.32141 17.5736 17.5736C6.32141 28.8258 2.4028e-06 44.087 0 60L60 60H120Z"
      :fill="fill"
    />
    <path d="M61.0007 31.828V44H59.0007V31.828L53.6367 37.192L52.2227 35.778L60.0007 28L67.7787 35.778L66.3647 37.192L61.0007 31.828Z" fill="black" />
  </svg>
</template>

<style scoped lang="scss"></style>
